/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M11.6375 2C11.1593 3.00895 10.8918 4.13717 10.8918 5.32786C10.8918 9.62482 14.3752 13.1082 18.6722 13.1082C19.8629 13.1082 20.9911 12.8407 22 12.3626"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 11.9967C2 17.5214 6.47862 22 12.0033 22C17.4055 22 21.8075 17.7178 22 12.3626L11.6374 2C6.28224 2.19253 2 6.59454 2 11.9967Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 11.9967C2 17.5214 6.47862 22 12.0033 22C17.4055 22 21.8075 17.7178 22 12.3626C20.9911 12.8407 19.8628 13.1082 18.6721 13.1082C14.3752 13.1082 10.8918 9.62482 10.8918 5.32786C10.8918 4.13717 11.1593 3.00895 11.6374 2C6.28224 2.19253 2 6.59454 2 11.9967Z"
				fill="currentColor"
			/>
			<path
				d="M11.6374 2C11.1593 3.00895 10.8918 4.13717 10.8918 5.32786C10.8918 9.62482 14.3752 13.1082 18.6721 13.1082C19.8628 13.1082 20.9911 12.8407 22 12.3626M11.6374 2C6.28224 2.19253 2 6.59454 2 11.9967C2 17.5214 6.47862 22 12.0033 22C17.4055 22 21.8075 17.7178 22 12.3626M11.6374 2L22 12.3626"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M10.2702 1.38232C5.15516 2.2112 1.25 6.64772 1.25 11.9966C1.25 17.9355 6.06441 22.7499 12.0033 22.7499C17.3522 22.7499 21.7887 18.8448 22.6176 13.7297C21.4184 14.2936 20.08 14.6081 18.6721 14.6081C13.5468 14.6081 9.39182 10.4532 9.39182 5.32777C9.39182 3.91996 9.7063 2.58148 10.2702 1.38232Z"
				fill="currentColor"
			/>
			<path
				d="M11.6374 1.99991C11.4014 2.49785 11.2168 3.02485 11.0903 3.57407C10.9604 4.13769 10.8918 4.72472 10.8918 5.32777C10.8918 9.62473 14.3752 13.1081 18.6721 13.1081C19.2752 13.1081 19.8622 13.0395 20.4258 12.9097C20.9751 12.7831 21.5021 12.5985 22 12.3625L11.6374 1.99991Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M11.6374 2C11.1593 3.00895 10.8918 4.13717 10.8918 5.32786C10.8918 9.62482 14.3752 13.1082 18.6721 13.1082C19.8628 13.1082 20.9911 12.8407 22 12.3626L11.6374 2ZM11.6374 2C6.28224 2.19253 2 6.59454 2 11.9967C2 17.5214 6.47862 22 12.0033 22C16.1045 22 19.6293 19.5319 21.1733 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M11.6374 2C11.1593 3.00895 10.8918 4.13717 10.8918 5.32786C10.8918 9.62482 14.3752 13.1082 18.6721 13.1082C19.8628 13.1082 20.9911 12.8407 22 12.3626M11.6374 2C6.28224 2.19253 2 6.59454 2 11.9967C2 17.5214 6.47862 22 12.0033 22C17.4055 22 21.8075 17.7178 22 12.3626M11.6374 2L22 12.3626"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M1.25 11.9966C1.25 6.90357 4.79049 2.63772 9.54479 1.52573C10.0215 1.41422 10.5166 1.42204 11 1.49998L22.5 13C22.5779 13.4833 22.5857 13.9783 22.4742 14.455C21.3622 19.2094 17.0963 22.7499 12.0033 22.7499C6.06441 22.7499 1.25 17.9355 1.25 11.9966Z"
				fill="currentColor"
			/>
			<path
				d="M11 1.5C10.7451 2.03792 10.3511 3.10723 10.2144 3.70054C10.0741 4.30941 10 4.94357 10 5.59503C10 10.237 13.763 14 18.405 14C19.0564 14 19.6906 13.9259 20.2995 13.7856C20.8928 13.6489 21.9621 13.2549 22.5 13L11 1.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
